import {Component, Injector} from "@angular/core";
import {RetranslatorDialogBaseComponent} from "./retranslator-dialog-base/retranslator-dialog-base.component";

@Component({
    selector: 'app-retranslator-edit',
    templateUrl: './retranslator-dialog-base/retranslator-dialog-base.component.html',
    styleUrls: ['./retranslator-dialog-base/retranslator-dialog-base.component.css'],
    standalone: false
})
export class EditRetranslatorComponent extends RetranslatorDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "editRetranslation";
  }


  public submit() {
    if (!this.validate())
      return;
    this.retranslationService.EditRetranslation(this.model)
        .subscribe((res) => {
            this.onCreated.emit();
            this.close();
            super.submit();
        });
  }
}
